import React from 'react';
import { StatType } from '../../../../../shared/CharacterTypes';
import { formatResourceValue, getStatAbbreviation, getStatDescription } from './StatHelpers';
import { StatLedgerRow } from './StatLedgerRow';

interface ResourceStatsPanelProps {
  health: number;
  maxHealth: number;
  mana: number;
  maxMana: number;
}

export const ResourceStatsPanel: React.FC<ResourceStatsPanelProps> = ({
  health,
  maxHealth,
  mana,
  maxMana,
}) => (
  <section className="character-stat-section" aria-labelledby="character-resource-stats-heading">
    <h3 id="character-resource-stats-heading">Resources</h3>
    <p className="character-stat-section__intro">Current values remain distinct from their maxima.</p>
    <div className="character-stat-list" role="list">
      <StatLedgerRow
        statType={StatType.HEALTH}
        abbreviation={getStatAbbreviation(StatType.HEALTH)}
        label="Health"
        value={health}
        description={getStatDescription(StatType.HEALTH)}
        formatValue={value => formatResourceValue(value, maxHealth)}
      />
      <StatLedgerRow
        statType={StatType.MANA}
        abbreviation={getStatAbbreviation(StatType.MANA)}
        label="Mana"
        value={mana}
        description={getStatDescription(StatType.MANA)}
        formatValue={value => formatResourceValue(value, maxMana)}
      />
    </div>
  </section>
);
